'use client';
import { useCallback, useEffect, useRef } from 'react';

export const useScrollIfHashed = (target: string) => {
  const ref = useRef<HTMLDivElement>(null);

  const scrollToRef = useCallback(
    (hash: string) => {
      // 正規表現で#以降の文字列を取得
      const match = hash.match(/#(.+)/);
      if (hash && match && match[1] === target) {
        if (ref.current) {
          ref.current.scrollIntoView({ block: 'start' });
        }
      }
    },
    [target]
  );

  const hashChangeHandler = useCallback(() => {
    scrollToRef(window.location.hash);
  }, [scrollToRef]);

  useEffect(() => {
    scrollToRef(window.location.hash);
  }, [scrollToRef]);

  useEffect(() => {
    window.addEventListener('hashchange', hashChangeHandler);
    return () => {
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, [hashChangeHandler]);

  return ref;
};
